import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

// Legacy /letter/* API functions are disabled because these paths are absent
// from the current backend schema.
// export const letterCreate = ...
// export const letterIncomingList = ...
// export const letterOutgoingList = ...
// export const letterDelete = ...
// export const letterStatus = ...
// export const letterPublicInfo = ...

export const externalLettersList: ApiFunc<`${typeof API.EXTERNAL_LETTERS_LIST}`, 'get'> = data =>
  instance.get(API.EXTERNAL_LETTERS_LIST, { params: data })

export const externalLetterRegister: ApiFunc<`${typeof API.EXTERNAL_LETTERS_REGISTER}`, 'post'> = data =>
  instance.post(API.EXTERNAL_LETTERS_REGISTER, data)

export const externalLetterItem: ApiFunc<`${typeof API.EXTERNAL_LETTERS_LIST}{id}`, 'get'> = data =>
  instance.get(`${API.EXTERNAL_LETTERS_LIST}${'id' in data ? data.id : data.name}`)

export const externalLetterDelete: ApiFunc<`${typeof API.EXTERNAL_LETTERS_LIST}{id}`, 'delete'> = data =>
  instance.delete(`${API.EXTERNAL_LETTERS_LIST}${'id' in data ? data.id : data.name}`)

export const externalLetterCommentTemplates: ApiFunc<`${typeof API.EXTERNAL_LETTERS_COMMENT_TEMPLATE}`, 'get'> = () =>
  instance.get(API.EXTERNAL_LETTERS_COMMENT_TEMPLATE)

export const externalLetterCommentTemplateCreate: ApiFunc<
  `${typeof API.EXTERNAL_LETTERS_COMMENT_TEMPLATE}`,
  'post'
> = data => instance.post(API.EXTERNAL_LETTERS_COMMENT_TEMPLATE, data)

export const externalLetterCommentTemplateDelete: ApiFunc<
  `${typeof API.EXTERNAL_LETTERS_COMMENT_TEMPLATE}{id}`,
  'delete'
> = data => instance.delete(`${API.EXTERNAL_LETTERS_COMMENT_TEMPLATE}${'id' in data ? data.id : data.name}`)

export const externalLetterSendToInform: ApiFunc<`${typeof API.EXTERNAL_LETTERS_SEND_TO_INFORM}`, 'post'> = data =>
  instance.post(API.EXTERNAL_LETTERS_SEND_TO_INFORM, data)

export const externalLetterProvideResolution: ApiFunc<`${typeof API.EXTERNAL_LETTERS_RESOLUTION}`, 'post'> = data =>
  instance.post(API.EXTERNAL_LETTERS_RESOLUTION, data)

export const externalLetterConfirmInformed: ApiFunc<`${typeof API.EXTERNAL_LETTERS_CONFIRM_INFORMED}`, 'post'> = data =>
  instance.post(API.EXTERNAL_LETTERS_CONFIRM_INFORMED, data)

export const externalLetterCompleteExecution: ApiFunc<
  `${typeof API.EXTERNAL_LETTERS_COMPLETE_EXECUTION}`,
  'post'
> = data => instance.post(API.EXTERNAL_LETTERS_COMPLETE_EXECUTION, data)

export const externalLetterRequireUpdate: ApiFunc<`${typeof API.EXTERNAL_LETTERS_REQUIRE_UPDATE}`, 'post'> = data =>
  instance.post(API.EXTERNAL_LETTERS_REQUIRE_UPDATE, data)

export const externalLetterComplete: ApiFunc<`${typeof API.EXTERNAL_LETTERS_COMPLETE}`, 'post'> = data =>
  instance.post(API.EXTERNAL_LETTERS_COMPLETE, data)
